import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'page-heading',
    templateUrl: './page-heading.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageHeadingComponent {
  @Input() title: string
  @Input() description: string
  @Input() hasBreadcrumb: boolean = false
  @Input() breadcrumb: Array<{ href?: string; label: string }>
}
